import { Select, useComputedColorScheme } from '@mantine/core';
import { License } from 'interfaces';
import { useActiveForm } from 'pages/claims/components/ClaimFormProvider';
import React, { useMemo } from 'react';
import { useCurrentSiteStore } from 'store';
import { getValueByPath } from 'utils/getValueByPath';

interface ModalBillingNumberInputProps {
  label: string;
  required?: boolean;
  accessorKey: string;
  type?: string;
  hotkey?: string;
}
export const ModalBillingNumberInput: React.FC<ModalBillingNumberInputProps> =
  React.memo(({ label, required = false, accessorKey }) => {
    const computedColorScheme = useComputedColorScheme('dark');
    const color = computedColorScheme === 'dark' ? 'white' : 'black';
    const { form, prefix } = useActiveForm();
    const { id: siteID } = useCurrentSiteStore();
    const licensesPath = prefix ? `${prefix}.${accessorKey}` : accessorKey;
    const payorPath = prefix ? `${prefix}.payorID` : 'payorID';

    const licenses =
      (getValueByPath(form.getValues(), licensesPath) as License[]) || [];
    const payorID = getValueByPath(form.getValues(), payorPath);

    const licenseMatch = licenses
      .filter((license) => license.siteID === siteID)
      .find((license: License) => license.payorID === payorID);
    const selectedValue = licenseMatch?.license || null;

    const data = useMemo(() => {
      const options = licenses
        .filter((license) => license.siteID === siteID)
        .map((license) => ({
          value: license.license,
          label: `${license.license} - (${license.payorName})`,
        }));

      return options;
    }, [licenses, siteID]);

    return (
      <Select
        radius={'md'}
        withAsterisk={required}
        size="md"
        label={label}
        c={color}
        data={data}
        value={selectedValue}
        allowDeselect={false}
        searchable
        disabled={true}
        data-testid="billing-number-select"
      />
    );
  });
